import { render, staticRenderFns } from "./ModalConfirmGdlsCode.vue?vue&type=template&id=ca367296&scoped=true&lang=pug&"
import script from "./ModalConfirmGdlsCode.vue?vue&type=script&lang=ts&"
export * from "./ModalConfirmGdlsCode.vue?vue&type=script&lang=ts&"
import style0 from "./ModalConfirmGdlsCode.vue?vue&type=style&index=0&id=ca367296&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca367296",
  null
  
)

export default component.exports